import { useContext, useMemo } from 'react';
import { userContext } from 'contexts/UserContext';

import { PermissionCheck } from '../types';

export function useHasPermission(permission: PermissionCheck): boolean {
  const { user } = useContext(userContext);
  return useMemo(() => permission(user), [permission, user]);
}
